import React, { memo } from 'react'
import { Typography } from 'transfix-ui/core'
import * as Types from 'apps/fleet-planner/types'
import { ShareLoadAlreadySharedAlert } from './ShareLoadAlreadySharedAlert'
import { ShareLoadSmsEnabledAlert } from './ShareLoadSmsEnabledAlert'
import { ShareLoadTooltip } from './ShareLoadTooltip'

interface IShareLoadDriverInfoProps {
  selectedDriver: Types.IDriver | undefined
  isSharedWithSelectedDriver: boolean
  assignedDriver: Types.IDriver | undefined
  shipment: Types.ILoad
}

export const ShareLoadDriverInfo = memo<IShareLoadDriverInfoProps>(
  ({ assignedDriver, isSharedWithSelectedDriver, selectedDriver, shipment }) => {
    const { id: assignedDriverId, smsStatusEnabledForShipment } = assignedDriver || {}
    const { settings } = selectedDriver || {}
    const { isExternal } = shipment || {}
    return (
      <>
        {isSharedWithSelectedDriver && (
          <ShareLoadAlreadySharedAlert
            sharedWithDriver={isSharedWithSelectedDriver}
            settings={settings}
          />
        )}

        <ShareLoadSmsEnabledAlert
          settings={settings}
          shipmentSMSEnabled={smsStatusEnabledForShipment}
          isExternal={isExternal}
        />
        <div className='flex mb4'>
          <Typography variant='subtitle1' color='textPrimary' className='mr4 flex items-center'>
            Share with Driver
          </Typography>
          <ShareLoadTooltip driverId={assignedDriverId} />
        </div>
      </>
    )
  }
)
